import { doc, getDoc, getFirestore } from "firebase/firestore";
import firebaseApp from "../components/database";

const db = getFirestore(firebaseApp);

const ClientLocationsService = {

    async getLocation(clientId, locationId): Promise<any> {

        try {
            console.log(`ClientLocationsService.getLocation: Starting with clientId: ${clientId}, locationId: ${locationId}`);

            const document = await getDoc(doc(db, "clients", clientId, "locations", locationId));
            console.log("ClientLocationsService.getLocation: Document fetched, exists:", document.exists());
            
            if (document.exists()) {
                const location: any = document.data();
                location.id = locationId;

                // fix, for wrong stored property
                if (location.openingHours) location.openingHours.enabled = true;

                // set default values
                if (location.isAddressVisible === undefined) location.isAddressVisible = true;
                if (location.isOpenHoursVisible === undefined) location.isOpenHoursVisible = true;
                if (location.isLogoVisible === undefined) location.isLogoVisible = true;

                console.log("ClientLocationsService.getLocation: Location data processed successfully");
                return location;

            } else {
                console.error("getLocation: No such document: " + locationId);
            }

        } catch (error) {
            console.error("Error getting location: ", error);
            console.error("Error details:", {
                message: (error as any).message,
                code: (error as any).code,
                stack: (error as any).stack
            });
            return null;
        }

    }

}

export default ClientLocationsService;